if (!customElements.get('luxe-booking-total')) {
  customElements.define('luxe-booking-total', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.labels = JSON.parse(this.querySelector('[data-booking-labels]').textContent);
      this.schedule = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 40); };
      this.root.addEventListener('input', this.schedule);
      this.root.addEventListener('change', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, {childList:true, subtree:true, attributes:true, characterData:true});
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.root?.removeEventListener('input', this.schedule);
      this.root?.removeEventListener('change', this.schedule);
    }
    readMoney(text) {
      const value = Number((text || '').replace(/[^0-9.,-]/g, '').replace(/,/g, ''));
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    }
    update() {
      if (!this.isConnected) return;
      const placement = this.querySelector('square-placement');
      const currency = placement.dataset.currency;
      const format = cents => new Intl.NumberFormat(placement.dataset.consumerLocale, {style:'currency', currency}).format(cents / 100) + ' ' + currency;
      let base = Number(this.dataset.baseCents);
      const recap = this.root.querySelector('#izyRecap .recap_price .amount');
      if (recap && recap.textContent.trim()) base = this.readMoney(recap.textContent);
      if (!Number.isFinite(base)) return;
      let total = base;
      let valid = true;
      const lines = [[this.labels.package, base]];
      const skus = [this.dataset.baseSku];
      this.root.querySelectorAll('#izyAddons .izyAddon').forEach(addon => {
        if (!addon.querySelector('.izyBox')?.checked) return;
        const input = addon.querySelector('.addonQty');
        const quantity = input ? Number(input.value) : 1;
        if (!Number.isInteger(quantity) || quantity < 1) { valid = false; return; }
        const appTotal = addon.querySelector('.addonPrice')?.getAttribute('data-total');
        const cents = appTotal !== null && appTotal !== undefined ? Number(appTotal) : Number(addon.dataset.price) * quantity;
        if (!Number.isFinite(cents) || cents < 0) { valid = false; return; }
        lines.push([(input ? quantity + ' × ' : '') + addon.dataset.title, cents]);
        total += cents;
        skus.push(addon.dataset.variant);
      });
      let config = typeof izyrent_metafields === 'undefined' ? null : izyrent_metafields;
      if (typeof config === 'string') { try { config = JSON.parse(config); } catch { config = null; } }
      let bond = Math.round(Number(config?.deposit?.amount || 0) * 100);
      const percent = Number(config?.deposit?.percent || 0);
      if (percent) bond += Math.round(base * percent / 100);
      const bondNode = this.root.querySelector('#izydeposit #depositlabel span');
      if (bondNode) bond = this.readMoney(bondNode.textContent);
      if (!Number.isFinite(bond)) { valid = false; bond = 0; }
      if (bond > 0) { lines.push([this.labels.bond, bond]); total += bond; }
      const signature = JSON.stringify([lines,total,valid,skus]);
      if (signature === this.signature) return;
      this.signature = signature;
      const list = this.querySelector('[data-booking-lines]');
      list.replaceChildren(...lines.map(([label,cents]) => {
        const row = document.createElement('div');
        const dt = document.createElement('dt'); dt.textContent = label;
        const dd = document.createElement('dd'); dd.textContent = format(cents);
        row.append(dt,dd); return row;
      }));
      this.querySelector('[data-booking-total]').textContent = valid ? format(total) : this.labels.quantity_error;
      placement.hidden = !valid;
      if (valid) {
        placement.dataset.amount = (total / 100).toFixed(2);
        placement.dataset.itemSkus = skus.join(',');
      }
    }
  });
}